import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

// 멱등 처리되는 동의 기록 API. 성공 시 data 는 null 로 내려온다.
const AgreeSeedingTermsResponseDataSchema = z
  .null()
  .describe('AgreeSeedingTermsResponseDataSchema');

const AgreeSeedingTermsResponseSchema = createApiResponseSchema(
  AgreeSeedingTermsResponseDataSchema,
);

export type AgreeSeedingTermsResponse = z.infer<typeof AgreeSeedingTermsResponseSchema>;

export const agreeSeedingTerms = withApiErrorCapture(
  lazyPipe(
    async () =>
      executeStandardRequest(async () =>
        partnerHttpClient.post<AgreeSeedingTermsResponse>(partnerApiPath.seedingTermsAgreement, {}),
      ),
    validateApiResponse(AgreeSeedingTermsResponseSchema),
  ),
);
